// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { type StickyMatchActionsRowContext } from '../../constants/match';
import useMergeProps from '../../hooks/useMergeProps';
import { type MatchBetFilter } from '../../utils/contexts';

import StickyMatchActionsRow from './StickyMatchActionsRow';
import makeStickyMatchActionsRowPropsSelector from './StickyMatchActionsRow.selector';

type StickyMatchActionsRowContainerProps = {
  className?: string;
  matchId: number;
  filters: Array<MatchBetFilter>;
  onFilterChanged: (filterId: string | null) => void;
  defaultFilterId?: string;
  untoggleable?: boolean;
  noAutoScroll?: boolean;
  context?: StickyMatchActionsRowContext;
};

const StickyMatchActionsRowContainer = (ownProps: StickyMatchActionsRowContainerProps) => {
  const selector = useMemo(() => makeStickyMatchActionsRowPropsSelector(), []);
  const selectedProps = useSelector((state) => selector(state, ownProps));

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { matchId, ...otherProps } = ownProps;

  const enhancedProps = useMergeProps({ selectedProps, otherProps });

  return <StickyMatchActionsRow {...enhancedProps} />;
};

export default StickyMatchActionsRowContainer;
